import {isObservable, toJS} from "mobx";
import cloneDeep from "lodash/cloneDeep";

export function cloneDeepSafe<T>(value: T): T {
  if (isObservable(value)) {
    return toJS(value);
  }
  else {
    return cloneDeep(value);
  }
}
